export function LandingPage() {
  return <div>Welcome to Appretio!</div>;
}
